<div class="password-card">
    <div class="card-header">
        <span class="card-title">Senha Expirada</span>
    </div>
    <nz-spin [nzSpinning]="saving">
    <div class="card-body">
        <div class="content" [formGroup]="senhaGroup">

            <div class="sideLeftPassWord">
                <div class="tem-field">
                    <label class="tem-field-label">Senha<span class="tem-field-required"> *</span></label>
                    <nz-input-group [nzSuffix]="suffixPass">
                        <input nz-input placeholder="Senha" formControlName="password" [type]="hide ? 'password' : 'text'">
                    </nz-input-group>
                    <ng-template #suffixPass>
                        <nz-icon class="eye-toggle" [nzType]="hide ? 'eye-invisible' : 'eye'" (click)="hide = !hide"></nz-icon>
                    </ng-template>
                </div>

                <label class="col"
                    [ngClass]="senhaGroup.controls['password'].hasError('required') || senhaGroup.controls['password'].hasError('minlength')  ? 'text-danger' : 'text-success'">
                    <nz-icon [nzType]="senhaGroup.controls['password'].hasError('required') || senhaGroup.controls['password'].hasError('minlength') ? 'close-circle' : 'check-circle'"></nz-icon>
                    Deve conter no mínimo 12 caracteres.
                </label>

                <label class="col"
                    [ngClass]="senhaGroup.controls['password'].hasError('required') || senhaGroup.controls['password'].hasError('hasNumber')  ? 'text-danger' : 'text-success'">
                    <nz-icon [nzType]="senhaGroup.controls['password'].hasError('required') || senhaGroup.controls['password'].hasError('hasNumber') ? 'close-circle' : 'check-circle'"></nz-icon>
                    Deve conter no mínimo 1 número.
                </label>

                <label class="col"
                    [ngClass]="senhaGroup.controls['password'].hasError('required') || senhaGroup.controls['password'].hasError('hasCapitalCase')  ? 'text-danger' : 'text-success'">
                    <nz-icon [nzType]="senhaGroup.controls['password'].hasError('required') || senhaGroup.controls['password'].hasError('hasCapitalCase') ? 'close-circle' : 'check-circle'"></nz-icon>
                    Deve conter no mínimo 1 letra maíscula.
                </label>

                <label class="col"
                    [ngClass]="senhaGroup.controls['password'].hasError('required') || senhaGroup.controls['password'].hasError('hasSmallCase')  ? 'text-danger' : 'text-success'">
                    <nz-icon [nzType]="senhaGroup.controls['password'].hasError('required') || senhaGroup.controls['password'].hasError('hasSmallCase') ? 'close-circle' : 'check-circle'"></nz-icon>
                    Deve conter no mínimo 1 letra minúscula.
                </label>

                <label class="col"
                    [ngClass]="senhaGroup.controls['password'].hasError('required') || senhaGroup.controls['password'].hasError('hasSpecialCharacter')  ? 'text-danger' : 'text-success'">
                    <nz-icon [nzType]="senhaGroup.controls['password'].hasError('required') || senhaGroup.controls['password'].hasError('hasSpecialCharacter') ? 'close-circle' : 'check-circle'"></nz-icon>
                    Deve conter no mínimo 1 carácter especial.
                </label>

            </div>
            <div class="sideRightPassWord">
                <div class="tem-field">
                    <label class="tem-field-label">Confirmação de Senha<span class="tem-field-required"> *</span></label>
                    <nz-input-group [nzSuffix]="suffixConf">
                        <input nz-input placeholder="Confirmação de Senha" formControlName="confirmacao" [type]="hideConfirmacao ? 'password' : 'text'" (keyup.enter)="sair()">
                    </nz-input-group>
                    <ng-template #suffixConf>
                        <nz-icon class="eye-toggle" [nzType]="hideConfirmacao ? 'eye-invisible' : 'eye'" (click)="hideConfirmacao = !hideConfirmacao"></nz-icon>
                    </ng-template>
                    <div class="field-error" *ngIf="confirmacao.touched && confirmacao.errors && confirmacao.errors.senhasNaoCoincidem">
                        <b>Senha e confirmação de senha não coincidem.</b>
                    </div>
                    <div class="field-error" *ngIf="confirmacao.touched && confirmacao.errors && confirmacao.errors.samePassword">
                        <b>Senha deve ser diferente da anterior.</b>
                    </div>
                </div>
            </div>
            <div class="mfa-code" *ngIf="needMFA">
                <div class="tem-field">
                    <label class="tem-field-label">Código MFA<span class="tem-field-required"> *</span></label>
                    <input nz-input placeholder="Código MFA" formControlName="mfaCode">
                    <div class="field-error" *ngIf="senhaGroup.controls['mfaCode'].touched && senhaGroup.controls['mfaCode'].hasError('required')">
                        Código MFA é obrigatório.
                    </div>
                </div>
            </div>
        </div>
    </div>
    </nz-spin>
    <div class="button-content">
        <div class="spacer"></div>
        <span><button nz-button nzType="primary" (click)="sair()" [disabled]="disabled">Alterar</button></span>
    </div>
</div>
